<script setup lang="ts">
import { Layout } from 'ant-design-vue'
import { RouterView, useRoute } from 'vue-router'
import LeftSider from '@/views/model/layout/LeftSider.vue'
import { computed } from 'vue'

import {
  PathJsonRoutesDataItem,
  RoutesDataItem,
  jsonPathVueRoutes,
  vueRoutes,
} from '@/utils/routes'
import { cloudHost } from '@/router/modules/menu'
import { Scenes } from '@/enum'

const route = useRoute()

// 框架所有菜单路由
const menuData: RoutesDataItem[] = vueRoutes(cloudHost).filter((item) => !item.meta?.hideInMenu)

// 框架所有的路由转成json并统一添加了parentPath
const jsonPathRoutes: PathJsonRoutesDataItem = jsonPathVueRoutes(menuData)

// 当前路由 item
const routeItem = computed<RoutesDataItem>(() => {
  // if (route?.query?.scene) {
  // 根据 activeMenu 来高亮侧边栏
  return jsonPathRoutes[`${route.path}?scene=${route.query.scene || Scenes.Generic}`]
  // }
  // return getJsonRouteItem(route.path, jsonPathRoutes)
})
</script>

<template>
  <div class="console-page-container">
    <Layout class="console-main">
      <Layout.Sider class="console-left">
        <LeftSider :menu-data="menuData" :route-item="routeItem" />
      </Layout.Sider>
      <Layout.Content>
        <router-view />
      </Layout.Content>
    </Layout>
  </div>
</template>

<style lang="less" scoped>
.console-page-container {
  background: #f5f5f5;
  margin: 1.2rem;
}
.console-left {
  flex: 0 0 10% !important;
  min-width: 216px !important;
  width: 10% !important;
  max-width: 300px !important;
  margin-right: 0 !important;
}
.console-main {
  height: 100%;
  background: #f5f5f5;
  margin: 0 auto;
  &:deep(.ant-layout-sider) {
    background: #fff;
    border-radius: 0.4rem;
    margin-right: 24px;
    .ant-layout-sider-children {
      border-radius: 0.4rem;
      overflow: hidden;
      .logo {
        padding: 16px;
        span {
          height: 26px;
          color: #333;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
      }
    }
  }
  &:deep(.ant-layout-content) {
    background: transparent;
    // width: 960px;
    overflow: auto;
    padding-left: 20px;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
      // width: 0;
      // height: 0;
      // background: transparent;
    }
  }
}
</style>
